import React, { useState } from 'react';
import logo from '../../assets/image/logo.png';
import chessimg20 from '../../assets/image/chessimg20.jpeg';
import './Contact.css';
import axios from 'axios';


const Contact = () => {


  const [formData, setFormData] = useState({
    message: "",
    name: "",
    email: "",
    subject: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear error when user starts typing
    setErrors({ ...errors, [name]: "" });
  };

  // Validate fields
  const validate = () => {
    const newErrors = {};
    if (!formData.message.trim()) newErrors.message = "Message is required.";
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Enter a valid email address.";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
    return newErrors;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    setLoading(true);
    try {
      const res = await axios.post("http://localhost:5544/api/sendMail", formData);

      alert(res.data.message);
      if (res.data.success === 1) {
        setFormData({ email: "", message: "", name: "", subject: "" });
      }
    } catch (err) {
      console.error(err);
      alert("Error sending email");
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="contact-page">
      {/* Preloader */}
      <div id="preloader-active">
        <div className="preloader d-flex align-items-center justify-content-center">
          <div className="preloader-inner position-relative">
            <div className="preloader-circle"></div>
            <div className="preloader-img pere-text">
              <img src={logo} alt="Loading..." />
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <div className="slider-area">
          <div
            className="single-slider hero-overly slider-height d-flex align-items-center"
            style={{
              backgroundImage: `url(${chessimg20})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '400px',
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="hero-cap">
                    <h2>Contact Us</h2>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item"><a href="#">Contact</a></li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            {/* Borivali Location */}
            <div className="row">
              <div className="col-lg-9 google-maps">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15068.467692577056!2d72.8567217!3d19.2337354!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b0de9f28e0fb%3A0xd457b7578650f19c!2sKing%20Maker%20Chess%20Academy!5e0!3m2!1sen!2sin!4v1682514486677!5m2!1sen!2sin"
                  width="800"
                  height="550"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Borivali Location"
                ></iframe>
              </div>
              <div className="col-lg-3">
                <br /><br />
                <div className="media contact-info">
                  <span className="contact-info__icon"><i className="ti-home"></i></span>
                  <div className="media-body">
                    <h3>Borivali West</h3>
                    <p>604, Ganjawala Residency, Ganjawala Ln, Mumbai, Maharashtra 400092</p>
                  </div>
                </div>
                <div className="media contact-info">
                  <span className="contact-info__icon"><i className="ti-tablet"></i></span>
                  <div className="media-body">
                    <h3>09920650996</h3>
                    <p>Mon to Fri 9am to 6pm</p>
                  </div>
                </div>
                <div className="media contact-info">
                  <span className="contact-info__icon"><i className="ti-email"></i></span>
                  <div className="media-body">
                    <h3>kingmakerca@gmail.com</h3>
                    <p>Send us your query anytime!</p>
                  </div>
                </div>
              </div>
            </div>

            <br /><br />

            {/* Marine Lines Location */}
            <div className="row">
              <div className="col-lg-9 google-maps">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15095.286008870853!2d72.8284958!3d18.9392934!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d10ee2352803%3A0x4d83cf8144949127!2sKing%20Maker%20Chess%20Academy!5e0!3m2!1sen!2sin!4v1682516731497!5m2!1sen!2sin"
                  width="800"
                  height="550"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Marine Lines Location"
                ></iframe>
              </div>
              <div className="col-lg-3">
                <br /><br />
                <div className="media contact-info">
                  <span className="contact-info__icon"><i className="ti-home"></i></span>
                  <div className="media-body">
                    <h3>Marine Lines</h3>
                    <p>211, Maker Bhavan 3, 21, behind Ayakar Bhavan, New Marine Lines, Marine Lines, Mumbai, Maharashtra 400020</p>
                  </div>
                </div>
                <div className="media contact-info">
                  <span className="contact-info__icon"><i className="ti-tablet"></i></span>
                  <div className="media-body">
                    <h3>09920650996</h3>
                    <p>Mon to Fri 9am to 6pm</p>
                  </div>
                </div>
                <div className="media contact-info">
                  <span className="contact-info__icon"><i className="ti-email"></i></span>
                  <div className="media-body">
                    <h3>kingmakerca@gmail.com</h3>
                    <p>Send us your query anytime!</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="container mt-5 position-relative">
              {/* Loader overlay */}
              {loading && (
                <div className="loader-overlay">
                  <div className="loader"></div>
                </div>
              )}

              <h2 className="text-center mb-4">Get in Touch</h2>
              <form onSubmit={handleSubmit} className="w-75 mx-auto">
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="4"
                    placeholder="Enter Message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                  {errors.message && <p className="text-danger small mb-0">{errors.message}</p>}
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      className="form-control"
                      name="name"
                      type="text"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && <p className="text-danger small mb-0">{errors.name}</p>}
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      className="form-control"
                      name="email"
                      type="email"
                      placeholder="Enter email address"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <p className="text-danger small mb-0">{errors.email}</p>}
                  </div>
                </div>

                <div className="mb-3">
                  <input
                    className="form-control"
                    name="subject"
                    type="text"
                    placeholder="Enter Subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                  {errors.subject && <p className="text-danger small mb-0">{errors.subject}</p>}
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>

      <div id="back-top" style={{ textAlign: 'center' }}>
        <a title="Go to Top" href="#" style={{ display: 'inline-block' }}>
          <i className="fas fa-level-up-alt"></i>
        </a>
      </div>
    </div>
  );
}

export default Contact;
